import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { ASSETS } from "@/data";
import { ReviewFlash } from "@/components/ReviewFlash";

const ease = [0.16, 1, 0.3, 1];

export default function About() {
  return (
    <section id="about" className="relative py-24 lg:py-32" data-testid="about-section">
      <div className="mx-auto max-w-[1200px] px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Photo */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease }}
          className="gold-frame rounded-sm overflow-hidden order-1 relative"
        >
          <img
            src={ASSETS.aboutPhoto}
            alt="Fairy Yasha performing a pendulum & tarot reading by candlelight"
            className="w-full h-auto block rounded-sm"
            data-testid="about-photo"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#0B0605]/85 via-transparent to-transparent" />
          <ReviewFlash />
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease }}
          className="order-2"
        >
          <span className="text-[11px] tracking-[0.4em] uppercase text-[#C9A24B]">✦ About Me ✦</span>
          <div className="mt-3 leading-none">
            <span className="block font-display uppercase tracking-[0.18em] text-[#EFE3CC] text-3xl">Fairy</span>
            <span className="block font-script text-gold-gradient text-6xl -mt-2 pl-1">Yasha</span>
          </div>

          <div className="mt-7 space-y-4 text-[#B7A488] font-light leading-relaxed">
            <p>
              I'm a psychic reader, medium and energy healer guided by intuition, spirit, and a deep love
              for the unseen. For as long as I can remember, I've felt the quiet whispers between worlds —
              and I've devoted my life to translating them with honesty and tenderness.
            </p>
            <p>
              Through tarot, the pendulum, energy healing and ritual, I help you hear the answers your spirit
              already holds — about love, purpose, and the crossroads you're standing at now. Every session is
              a sacred, judgment-free space held just for you.
            </p>
            <p className="text-[#CDBE9F] italic font-display text-xl">
              "You already have the answers. I'm here to help you hear them."
            </p>
          </div>

          <p className="mt-7 text-xs tracking-[0.28em] uppercase text-[#E9D3A0]">
            Intuition · Healing · Empowerment · Transformation
          </p>
          <span className="mt-4 flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-[#B7A488]" data-testid="about-location">
            <MapPin className="w-4 h-4 text-[#C9A24B]" strokeWidth={1.5} /> Charlotte, North Carolina
          </span>

          <a
            href="#pricing"
            data-testid="about-cta"
            className="mt-9 inline-block rounded-full border border-[#C9A24B]/50 px-10 py-4 text-xs tracking-[0.22em] uppercase text-[#EFE3CC] transition-all duration-300 hover:border-[#C9A24B] hover:bg-[#C9A24B]/10"
          >
            Work With Me
          </a>
        </motion.div>
      </div>
    </section>
  );
}
